<script setup lang="ts">
import DefaultLayout from '@/components/layouts/Default.vue'
import SessionExpiredModal from '@/components/shared/SessionExpiredModal.vue'
import { provide } from 'vue'
import { RouterView } from 'vue-router'

const props = defineProps<{
  isDark: boolean
}>()

provide('isDark', props.isDark)
</script>

<template>
  <DefaultLayout :is-dark="isDark">
    <RouterView />
  </DefaultLayout>
  <SessionExpiredModal />
</template>
